// eslint-disable-next-line import/no-extraneous-dependencies
import * as amplitude from '@amplitude/analytics-browser';
import { Modal } from '@components';
import { routes } from '@constants';
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import { authSlice, userApi } from '@store';
import { Button, Flex, theme, Typography } from '@styles';
import { ProfileTemplate } from '@templates';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { DeleteAccountModal } from './components';

const DeleteProfilePage = () => {
  const { i18n } = useTranslation();
  const { navigate } = useNavigateWithOfflineMode();
  const dispatch = useDispatch();
  const { isTabletSM } = useScreenSize();

  const [isVisible, setIsVisible] = useState(false);
  const [deleteAccount] = userApi.useDeleteAccountMutation();

  const handleOpenModal = () => {
    setIsVisible(true);
  };

  const handleDeleteAccount = async () => {
    await deleteAccount();

    amplitude.reset();
    dispatch(authSlice.actions.signOut());
    navigate(routes.mainPage);
  };

  return (
    <ProfileTemplate>
      <Flex flexDirection="column">
        <Typography
          color={theme.colors.white[100]}
          variant="MS-regular-s26-lh32"
        >
          {i18n.t('ProfilePage.DeleteProfile.DeleteAccount')}
        </Typography>
        <Typography
          color={theme.colors.alto[100]}
          mt={24}
          variant="MS-regular-s16-lh25"
        >
          {i18n.t('ProfilePage.DeleteProfile.BeforeDeleteAccount')}
        </Typography>
        <Typography
          color={theme.colors.schoolBusYellow[100]}
          variant="MS-regular-s16-lh25"
        >
          {i18n.t('ProfilePage.DeleteProfile.BeforeDeleteAccountYellowText')}
        </Typography>
        <Flex
          borderTopColor={theme.colors.tundora}
          borderTopStyle="solid"
          borderTopWidth={2}
          mt={120}
          pt={24}
        >
          <Button
            backgroundColor={theme.colors.red[60]}
            border="none"
            onClick={handleOpenModal}
            px={47}
            py={22}
            {...(isTabletSM && { width: '100%' })}
          >
            <Typography
              color={theme.colors.white[100]}
              variant="MS-bold-s16-lh25"
            >
              {i18n.t('ProfilePage.DeleteProfile.Delete').toUpperCase()}
            </Typography>
          </Button>
        </Flex>
      </Flex>
      <Modal
        firstButtonProps={{
          color: theme.colors.white[100],
          px: 47,
          py: 22,
          variant: 'secondary',
        }}
        firstButtonText={i18n
          .t('ProfilePage.DeleteProfile.Modal.Cancel')
          .toUpperCase()}
        isVisible={isVisible}
        modalContainerProps={{
          backgroundColor: theme.colors.white[10],
          border: `1px solid ${theme.colors.white[10]}`,
          borderRadius: '0px',
          height: '100%',
          maxHeight: isTabletSM ? '100%' : '310px',
        }}
        modalMaxHeight="100%"
        modalMaxWidth={550}
        onSecondButtonClick={handleDeleteAccount}
        secondButtonProps={{
          backgroundColor: theme.colors.red[60],
          border: 'none',
          color: theme.colors.white[100],
          px: 47,
          py: 22,
        }}
        secondButtonText={i18n
          .t('ProfilePage.DeleteProfile.Delete')
          .toUpperCase()}
        setModalVisible={setIsVisible}
        withBottomButtons
      >
        <DeleteAccountModal />
      </Modal>
    </ProfileTemplate>
  );
};

export default DeleteProfilePage;
